export const TENANT_LOCALE_OPTIONS = [
  { value: "pt-BR", labelKey: "settings.general.fields.locale.options.ptBR" },
  { value: "en", labelKey: "settings.general.fields.locale.options.en" },
  { value: "es", labelKey: "settings.general.fields.locale.options.es" },
] as const;

export const TENANT_TIMEZONE_OPTIONS = [
  { value: "America/Sao_Paulo", labelKey: "settings.general.fields.timezone.options.americaSaoPaulo" },
  { value: "America/Manaus", labelKey: "settings.general.fields.timezone.options.americaManaus" },
  { value: "America/Fortaleza", labelKey: "settings.general.fields.timezone.options.americaFortaleza" },
  { value: "America/Cuiaba", labelKey: "settings.general.fields.timezone.options.americaCuiaba" },
  { value: "America/Recife", labelKey: "settings.general.fields.timezone.options.americaRecife" },
  { value: "America/Noronha", labelKey: "settings.general.fields.timezone.options.americaNoronha" },
  { value: "America/New_York", labelKey: "settings.general.fields.timezone.options.americaNewYork" },
  { value: "America/Chicago", labelKey: "settings.general.fields.timezone.options.americaChicago" },
  { value: "America/Los_Angeles", labelKey: "settings.general.fields.timezone.options.americaLosAngeles" },
  { value: "Europe/Madrid", labelKey: "settings.general.fields.timezone.options.europeMadrid" },
  { value: "Europe/Lisbon", labelKey: "settings.general.fields.timezone.options.europeLisbon" },
  { value: "UTC", labelKey: "settings.general.fields.timezone.options.utc" },
] as const;

export const TENANT_CURRENCY_OPTIONS = [
  { value: "BRL", labelKey: "settings.general.fields.currency.options.brl" },
  { value: "USD", labelKey: "settings.general.fields.currency.options.usd" },
  { value: "EUR", labelKey: "settings.general.fields.currency.options.eur" },
] as const;

export interface RegionalSettingsFormValues {
  locale: string;
  timezone: string;
  currency_code: string;
}

export const mapSettingsToRegionalFormValues = (
  settings: Pick<RegionalSettingsFormValues, "locale" | "timezone" | "currency_code">
): RegionalSettingsFormValues => ({
  locale: settings.locale,
  timezone: settings.timezone,
  currency_code: settings.currency_code,
});
